import React from 'react';
import { useCommandPaletteRegistryCurrentAttribution } from '@atlassian/jira-command-palette';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries';

export const JiraCommandPaletteErrorBoundary = ({
	id,
	children,
}: {
	id: string;
	children: React.ReactNode | React.ReactNode[];
}) => {
	const [data] = useCommandPaletteRegistryCurrentAttribution();
	return (
		<JSErrorBoundary
			id={id}
			packageName="jiraCommandPaletteIntegration"
			fallback="unmount"
			teamName={data?.registryData?.teamName || 'deliveroo'}
			attributes={data?.analyticsAttributes}
		>
			{children}
		</JSErrorBoundary>
	);
};
